<template>
  <el-dialog
      :title="'新增寻源数据查询授权'"
      :close-on-click-modal="false"
      width="30%"
      :visible.sync="view.visible"
      @close="handleDialogClose">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="120px" class="position-dialog-form">
      <!-- 被授权用户搜索帮助 -->
      <el-form-item label="被授权用户" prop="objectUserId">
        <div
            class="search-help-wrapper"
            @click="toggleUserSearchHelp"
            :class="{ active: userSearchHelpVisible }"
        >
          <div class="search-help-display">
            <span v-if="dataForm.objectUserId" class="selected-text">
              {{ dataForm.objectUserName }} - {{ dataForm.objectUserRealName }}
            </span>
            <span v-else class="placeholder">请选择被授权用户</span>
          </div>
          <i class="el-icon-search search-icon"></i>
        </div>

        <!-- 用户搜索帮助弹窗 -->
        <div
            v-show="userSearchHelpVisible"
            class="search-help-sidebar"
            :style="userSidebarStyle"
        >
          <div class="search-help-header">
            <h4>选择被授权用户</h4>
            <el-button
                type="text"
                icon="el-icon-close"
                @click="userSearchHelpVisible = false"
                class="close-btn"
            ></el-button>
          </div>
          <div class="search-help-content">
            <div class="search-input-wrapper">
              <el-input
                  v-model="userSearchKeyword"
                  placeholder="请输入用户登录账号"
                  prefix-icon="el-icon-search"
                  @input="onUserSearch"
                  clearable
                  ref="userSearchInput"
              />
            </div>

            <!-- 修复：使用 v-if/v-else 结构替代 v-else-if -->
            <div v-if="userSearchResults.length > 0" class="search-results">
              <div
                  v-for="user in userSearchResults"
                  :key="user.id"
                  class="search-result-item"
                  @click="selectUser(user)"
              >
                <span class="user-code">{{ user.code }}</span>
                <span class="user-name">{{ user.name }}</span>
              </div>
            </div>

            <div v-else-if="userSearchKeyword && !userLoading" class="no-data">
              暂无匹配数据
            </div>

            <div v-else-if="userLoading" class="loading-data">
              <i class="el-icon-loading"></i> 加载中...
            </div>

            <div v-else-if="userSearchKeyword === '' && !userLoading" class="all-data">
              <div class="section-title">所有用户</div>
              <div
                  v-for="user in userList"
                  :key="user.id"
                  class="search-result-item"
                  @click="selectUser(user)"
              >
                <span class="user-code">{{ user.code }}</span>
                <span class="user-name">{{ user.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="dataForm.objectUserRealName" style="margin-top: 5px; color: #666;">
          姓名: {{ dataForm.objectUserRealName }}
        </div>
      </el-form-item>

      <!-- 授权采购组搜索帮助 -->
      <el-form-item label="授权采购组" prop="subjectPosId">
        <div
            class="search-help-wrapper"
            @click="togglePositionSearchHelp"
            :class="{ active: positionSearchHelpVisible }"
        >
          <div class="search-help-display">
            <span v-if="dataForm.subjectPosId" class="selected-text">
              {{ dataForm.subjectPosCode }} - {{ dataForm.subjectPosName }}
            </span>
            <span v-else class="placeholder">请选择授权采购组</span>
          </div>
          <i class="el-icon-search search-icon"></i>
        </div>

        <!-- 采购组搜索帮助弹窗 -->
        <div
            v-show="positionSearchHelpVisible"
            class="search-help-sidebar"
            :style="positionSidebarStyle"
        >
          <div class="search-help-header">
            <h4>选择授权采购组</h4>
            <el-button
                type="text"
                icon="el-icon-close"
                @click="positionSearchHelpVisible = false"
                class="close-btn"
            ></el-button>
          </div>
          <div class="search-help-content">
            <div class="search-input-wrapper">
              <el-input
                  v-model="positionSearchKeyword"
                  placeholder="请输入采购组编码"
                  prefix-icon="el-icon-search"
                  @input="onPositionSearch"
                  clearable
                  ref="positionSearchInput"
              />
            </div>

            <!-- 修复：使用 v-if/v-else 结构替代 v-else-if -->
            <div v-if="positionSearchResults.length > 0" class="search-results">
              <div
                  v-for="pos in positionSearchResults"
                  :key="pos.id"
                  class="search-result-item"
                  @click="selectPosition(pos)"
              >
                <span class="pos-code">{{ pos.code }}</span>
                <span class="pos-name">{{ pos.name }}</span>
              </div>
            </div>

            <div v-else-if="positionSearchKeyword && !positionLoading" class="no-data">
              暂无匹配数据
            </div>

            <div v-else-if="positionLoading" class="loading-data">
              <i class="el-icon-loading"></i> 加载中...
            </div>

            <div v-else-if="positionSearchKeyword === '' && !positionLoading" class="all-data">
              <div class="section-title">所有采购组</div>
              <div
                  v-for="pos in positionList"
                  :key="pos.id"
                  class="search-result-item"
                  @click="selectPosition(pos)"
              >
                <span class="pos-code">{{ pos.code }}</span>
                <span class="pos-name">{{ pos.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="dataForm.subjectPosName" style="margin-top: 5px; color: #666;">
          名称: {{ dataForm.subjectPosName }}
        </div>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="small" @click="view.visible = false">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()">
          确定
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import {insertXysq, queryUserList, queryPosList} from '@/controller/rfq'

export default {
  data() {
    return {
      userList: [], // 用户列表
      positionList: [], // 采购组列表
      userLoading: false,
      positionLoading: false,
      view: {
        visible: false,
        conheight: {
          height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
          'overflow-y': 'auto'
        }
      },
      dataForm: {
        id: '',
        objectUserId: '',       // 被授权用户ID
        objectUserName: '',     // 被授权用户名
        objectUserRealName: '', // 被授权用户姓名
        subjectPosId: '',       // 授权采购组ID
        subjectPosCode: '',     // 授权采购组代码
        subjectPosName: '',     // 授权采购组名称
        tenantId: '',
        mainBodyId: ''
      },
      dataRule: {
        objectUserId: [
          {required: true, message: '被授权用户不能为空', trigger: 'blur'}
        ],
        subjectPosId: [
          {required: true, message: '授权采购组不能为空', trigger: 'blur'}
        ]
      },
      // 搜索帮助相关数据
      userSearchHelpVisible: false,
      userSearchKeyword: '',
      userSearchResults: [],
      userSidebarStyle: {},
      positionSearchHelpVisible: false,
      positionSearchKeyword: '',
      positionSearchResults: [],
      positionSidebarStyle: {},
      // 用于存储初始表单数据，便于重置
      initialDataForm: {}
    }
  },
  methods: {
    init(id) {
      this.view.visible = true
      this.dataForm.id = id || ''
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        // 保存初始数据状态
        this.initialDataForm = {
          id: '',
          objectUserId: '',
          objectUserName: '',
          objectUserRealName: '',
          subjectPosId: '',
          subjectPosCode: '',
          subjectPosName: '',
          tenantId: '',
          mainBodyId: ''
        }
        this.dataForm.tenantId = sessionStorage.getItem('tenantId')
        this.dataForm.mainBodyId = sessionStorage.getItem('mainBodyId')

        // 初始化时加载数据
        this.loadUserList()
        this.loadPositionList()

        if (this.dataForm.id) {
          // 如果是修改，加载已有数据
          // 这里需要根据实际情况调用接口获取详情
        }
      })
    },

    // 处理对话框关闭事件
    handleDialogClose() {
      // 清除所有缓存数据和状态
      this.clearAllCache()
    },

    // 清除所有缓存数据
    clearAllCache() {
      // 重置表单数据
      this.dataForm = {
        id: '',
        objectUserId: '',
        objectUserName: '',
        objectUserRealName: '',
        subjectPosId: '',
        subjectPosCode: '',
        subjectPosName: '',
        tenantId: sessionStorage.getItem('tenantId'),
        mainBodyId: sessionStorage.getItem('mainBodyId')
      }

      // 重置搜索相关数据
      this.userList = []
      this.positionList = []
      this.userSearchHelpVisible = false
      this.userSearchKeyword = ''
      this.userSearchResults = []
      this.positionSearchHelpVisible = false
      this.positionSearchKeyword = ''
      this.positionSearchResults = []

      // 重置加载状态
      this.userLoading = false
      this.positionLoading = false

      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].resetFields()
        }
      })
    },

    // 加载用户列表
    async loadUserList() {
      this.userLoading = true
      try {
        const response = await queryUserList({})
        if (response && response.code === '00') {
          this.userList = response.body || []
        } else {
          this.$message.error(response.msg || '获取用户列表失败')
        }
      } catch (error) {
        console.error('获取用户列表异常:', error)
        this.$message.error('获取用户列表异常')
      } finally {
        this.userLoading = false
      }
    },

    // 加载采购组列表
    async loadPositionList() {
      this.positionLoading = true
      try {
        const response = await queryPosList({})
        if (response && response.code === '00') {
          this.positionList = response.body || []
        } else {
          this.$message.error(response.msg || '获取采购组列表失败')
        }
      } catch (error) {
        console.error('获取采购组列表异常:', error)
        this.$message.error('获取采购组列表异常')
      } finally {
        this.positionLoading = false
      }
    },

    // 搜索用户
    async onUserSearch() {
      if (!this.userSearchKeyword.trim()) {
        this.userSearchResults = []
        return
      }

      this.userLoading = true
      try {
        const response = await queryUserList({ objectUserName: this.userSearchKeyword })
        if (response && response.code === '00') {
          this.userSearchResults = response.body || []
        } else {
          this.$message.error(response.msg || '搜索用户失败')
          this.userSearchResults = []
        }
      } catch (error) {
        console.error('搜索用户异常:', error)
        this.$message.error('搜索用户异常')
        this.userSearchResults = []
      } finally {
        this.userLoading = false
      }
    },

    // 搜索采购组
    async onPositionSearch() {
      if (!this.positionSearchKeyword.trim()) {
        this.positionSearchResults = []
        return
      }

      this.positionLoading = true
      try {
        const response = await queryPosList({ subjectPosCode: this.positionSearchKeyword })
        if (response && response.code === '00') {
          this.positionSearchResults = response.body || []
        } else {
          this.$message.error(response.msg || '搜索采购组失败')
          this.positionSearchResults = []
        }
      } catch (error) {
        console.error('搜索采购组异常:', error)
        this.$message.error('搜索采购组异常')
        this.positionSearchResults = []
      } finally {
        this.positionLoading = false
      }
    },

    // 切换用户搜索帮助显示
    toggleUserSearchHelp() {
      this.userSearchHelpVisible = !this.userSearchHelpVisible
      if (this.userSearchHelpVisible) {
        this.userSearchKeyword = ''
        this.userSearchResults = []
        // 如果没有选中值，显示所有用户
        if (!this.dataForm.objectUserId) {
          this.userSearchResults = this.userList
        }
        this.$nextTick(() => {
          this.adjustUserSidebarPosition()
          // 聚焦搜索输入框
          if (this.$refs.userSearchInput) {
            this.$refs.userSearchInput.focus()
          }
        })
      }
    },

    // 切换采购组搜索帮助显示
    togglePositionSearchHelp() {
      this.positionSearchHelpVisible = !this.positionSearchHelpVisible
      if (this.positionSearchHelpVisible) {
        this.positionSearchKeyword = ''
        this.positionSearchResults = []
        // 如果没有选中值，显示所有采购组
        if (!this.dataForm.subjectPosId) {
          this.positionSearchResults = this.positionList
        }
        this.$nextTick(() => {
          this.adjustPositionSidebarPosition()
          // 聚焦搜索输入框
          if (this.$refs.positionSearchInput) {
            this.$refs.positionSearchInput.focus()
          }
        })
      }
    },

    // 调整用户侧边栏位置，确保在可视区域内
    adjustUserSidebarPosition() {
      this.$nextTick(() => {
        const sidebar = document.querySelector('.search-help-sidebar');
        if (!sidebar) return;

        const sidebarRect = sidebar.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sidebarHeight = 400; // 预估侧边栏高度
        const offset = 20; // 距离边缘的偏移量

        let top = offset;
        let maxHeight = sidebarHeight;

        // 如果距离底部空间不足，调整位置
        if (windowHeight - sidebarRect.top < sidebarHeight + offset) {
          // 显示在触发元素上方
          top = -sidebarHeight - offset;
        }

        // 确保不超过屏幕边界
        if (top < 0) {
          top = 10; // 如果上方空间也不足，则贴着顶部显示，浏览器会自动处理滚动
        }

        this.userSidebarStyle = {
          position: 'fixed',
          top: top + 'px',
          right: offset + 'px',
          width: '400px',
          maxHeight: Math.min(maxHeight, windowHeight - top - 40) + 'px',
          zIndex: 2001,
          backgroundColor: '#fff',
          border: '1px solid #e4e7ed',
          borderRadius: '4px',
          boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
        };

        // 设置内容区域最大高度以确保滚动条出现
        this.$nextTick(() => {
          const content = sidebar.querySelector('.search-help-content');
          const results = sidebar.querySelector('.search-results');
          if (content && results) {
            const headerHeight = 60; // 头部大概高度
            const inputHeight = 40; // 输入框大概高度
            const padding = 30; // 上下padding
            const availableHeight = parseInt(this.userSidebarStyle.maxHeight) - headerHeight - inputHeight - padding;
            if (results) {
              results.style.maxHeight = availableHeight + 'px';
              results.style.overflowY = 'auto';
            }
          }
        });
      });
    },

    // 调整采购组侧边栏位置
    adjustPositionSidebarPosition() {
      this.$nextTick(() => {
        const sidebar = document.querySelector('.search-help-sidebar');
        if (!sidebar) return;

        const sidebarRect = sidebar.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sidebarHeight = 400; // 预估侧边栏高度
        const offset = 20; // 距离边缘的偏移量

        let top = offset;
        let maxHeight = sidebarHeight;

        // 如果距离底部空间不足，调整位置
        if (windowHeight - sidebarRect.top < sidebarHeight + offset) {
          // 显示在触发元素上方
          top = -sidebarHeight - offset;
        }

        // 确保不超过屏幕边界
        if (top < 0) {
          top = 10; // 如果上方空间也不足，则贴着顶部显示，浏览器会自动处理滚动
        }

        this.positionSidebarStyle = {
          position: 'fixed',
          top: top + 'px',
          right: offset + 'px',
          width: '400px',
          maxHeight: Math.min(maxHeight, windowHeight - top - 40) + 'px',
          zIndex: 2001,
          backgroundColor: '#fff',
          border: '1px solid #e4e7ed',
          borderRadius: '4px',
          boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
        };

        // 设置内容区域最大高度以确保滚动条出现
        this.$nextTick(() => {
          const content = sidebar.querySelector('.search-help-content');
          const results = sidebar.querySelector('.search-results');
          if (content && results) {
            const headerHeight = 60; // 头部大概高度
            const inputHeight = 40; // 输入框大概高度
            const padding = 30; // 上下padding
            const availableHeight = parseInt(this.positionSidebarStyle.maxHeight) - headerHeight - inputHeight - padding;
            if (results) {
              results.style.maxHeight = availableHeight + 'px';
              results.style.overflowY = 'auto';
            }
          }
        });
      });
    },

    // 选择用户
    selectUser(user) {
      this.dataForm.objectUserId = user.id
      this.dataForm.objectUserName = user.code
      this.dataForm.objectUserRealName = user.name
      // 关键修复：手动清除该字段的验证状态
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate('objectUserId');
        }
      });
      this.userSearchHelpVisible = false
      this.userSearchKeyword = ''
      this.userSearchResults = []

    },

    // 选择采购组
    selectPosition(pos) {
      this.dataForm.subjectPosId = pos.id
      this.dataForm.subjectPosCode = pos.code
      this.dataForm.subjectPosName = pos.name
      // 关键修复：手动清除该字段的验证状态
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate('subjectPosId');
        }
      });
      this.positionSearchHelpVisible = false
      this.positionSearchKeyword = ''
      this.positionSearchResults = []
    },

    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate(async (valid) => {
        if (valid) {
          try {
            const params = {...this.dataForm}
            console.log('提交参数:', params)
            let response = await insertXysq(params)
            if (response && response.code === '00') {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.view.visible = false
                  this.$emit('refreshDataList')
                  // 清空表单数据
                  this.clearAllCache()
                }
              })
            } else {
              this.$message.error(response.msg || '操作失败')
            }
          } catch (error) {
            console.error('保存异常:', error)
            this.$message.error('保存异常')
          }
        }
      })
    }
  },

  // 监听窗口大小变化，调整侧边栏位置
  mounted() {
    window.addEventListener('resize', () => {
      if (this.userSearchHelpVisible) {
        this.adjustUserSidebarPosition();
      }
      if (this.positionSearchHelpVisible) {
        this.adjustPositionSidebarPosition();
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', () => {});
  }
}
</script>

<style scoped>
.search-help-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0 15px;
  height: 40px;
  cursor: pointer;
  background-color: #fff;
  transition: border-color 0.3s;
}

.search-help-wrapper:hover {
  border-color: #C0C4CC;
}

.search-help-wrapper.active {
  border-color: #409EFF;
}

.search-help-display {
  flex: 1;
  display: flex;
  align-items: center;
}

.selected-text {
  color: #606266;
  font-size: 14px;
}

.placeholder {
  color: #C0C4CC;
  font-size: 14px;
}

.search-icon {
  color: #C0C4CC;
  font-size: 16px;
  margin-left: 10px;
}

.search-help-content {
  max-height: 400px;
  overflow-y: auto;
}

.search-input-wrapper {
  margin-bottom: 15px;
}

/* 搜索结果区域 */
.search-results {
  max-height: 400px;
  overflow-y: auto;
}
.search-results {
  /* 确保容器不会影响子元素的显示 */
  background-color: transparent;
}
.search-help-content {
  background-color: #ffffff;
}
.search-results > .search-result-item:last-child {
  margin-bottom: 0;
  /* 明确设置背景色 */
  background-color: #ffffff;
}

.search-result-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  cursor: pointer;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: all 0.2s;
  /* 确保背景色始终一致，避免透明问题 */
  background-color: #ffffff;
}

.search-result-item:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}

.user-code, .pos-code {
  font-weight: 500;
  color: #303133;
  min-width: 60px;
  font-size: 14px;
}

.user-name, .pos-name {
  color: #606266;
  flex: 1;
  margin-left: 10px;
  text-align: left;
  font-size: 14px;
}

.no-data, .loading-data {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
  font-size: 14px;
}

.loading-data i {
  margin-right: 8px;
  font-size: 16px;
}

.all-data {
  margin-top: 15px;
}
.all-data > .search-result-item {
  /* 确保"所有数据"中的项目也有正确的背景色 */
  background-color: #ffffff;
  margin-bottom: 8px;
}
.all-data > .search-result-item:last-child {
  margin-bottom: 0;
}

.section-title {
  padding: 8px 12px;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 10px;
  border-radius: 4px;
}

.reference-hidden {
  display: none;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .search-help-sidebar {
    width: calc(100vw - 40px) !important;
    right: 20px !important;
  }

  .search-result-item {
    padding: 8px 10px;
  }

  .user-code, .pos-code {
    min-width: 50px;
    font-size: 13px;
  }

  .user-name, .pos-name {
    font-size: 13px;
    margin-left: 8px;
  }
}
</style>